/* __next_internal_client_entry_do_not_use__ default auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useNewOrder } from '@/context/NewOrderContext';
import { collection, doc, getDocs, query, updateDoc, where } from 'firebase/firestore';
import { firestore } from '@/lib/firebase/firebase';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from "__barrel_optimize__?names=Button,Dialog,DialogActions,DialogContent,DialogTitle,TextField!=!@mui/material";
import toast from 'react-hot-toast';
function ReferralCodeDialog() {
    const { order, setReferralCode } = useNewOrder();
    const [open, setOpen] = React.useState(false);
    const [referralCodeInput, setReferralCodeInput] = React.useState('');
    const [inputError, setInputError] = React.useState('');
    const handleReferralCodeApply = async (code)=>{
        const trimmedCode = code.trim();
        if (trimmedCode === '') {
            setInputError('Please enter a referral code before applying.');
            return;
        }
        try {
            const q = query(collection(firestore, 'referral_codes'), where('code', '==', trimmedCode));
            const snap = await getDocs(q);
            if (snap.empty) {
                setInputError('Invalid referral code.');
                return;
            } else {
                if (order.id) {
                    await updateDoc(doc(firestore, 'orders', order.id), {
                        referral_code: trimmedCode
                    });
                }
                setReferralCode(trimmedCode);
                setInputError('');
                setOpen(false);
                toast.success('Referral code applied successfully!');
            }
        } catch (error) {
            console.error('Error validating referral code:', error);
            setInputError('Failed to validate referral code. Please try again later.');
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsxs("p", {
                    className: "text-center text-sm md:text-base",
                    children: [
                        "Have a referral code?",
                        ' ',
                        /*#__PURE__*/ _jsx("span", {
                            className: "text-[var(--cyan)] font-semibold underline cursor-pointer",
                            onClick: ()=>setOpen(true),
                            children: "Apply"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsxs(Dialog, {
                open: open,
                onClose: ()=>setOpen(false),
                fullWidth: true,
                maxWidth: "xs",
                children: [
                    /*#__PURE__*/ _jsx(DialogTitle, {
                        children: "Enter Referral Code"
                    }),
                    /*#__PURE__*/ _jsx(DialogContent, {
                        children: /*#__PURE__*/ _jsx("div", {
                            className: "mt-1",
                            children: /*#__PURE__*/ _jsx(TextField, {
                                label: "Referral Code",
                                fullWidth: true,
                                value: referralCodeInput,
                                onChange: (e)=>setReferralCodeInput(e.target.value),
                                error: !!inputError,
                                helperText: inputError
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsxs(DialogActions, {
                        children: [
                            /*#__PURE__*/ _jsx(Button, {
                                onClick: ()=>setOpen(false),
                                variant: "outlined",
                                color: "primary",
                                children: "Cancel"
                            }),
                            /*#__PURE__*/ _jsx(Button, {
                                color: "primary",
                                variant: "contained",
                                onClick: ()=>handleReferralCodeApply(referralCodeInput),
                                children: "Apply"
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
export default ReferralCodeDialog;
